import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { persist } from 'zustand/middleware';

export type UserAuthStore = {
  user: any;
  email: string;
  token?: {
    access_token: string;
    expires_in: string;
  };
  logOut: () => void;
  setUser: (user: any | undefined) => void;
  setEmail: (mail: string) => void;
  setToken: (
    idToken:
      | {
          access_token: string;
          expires_in: string;
        }
      | undefined,
  ) => void;
};

export const useUserAuthStore = create(
  persist(
    immer<UserAuthStore>((set) => ({
      user: null,
      token: {
        access_token: '',
        expires_in: '',
      },
      email: '',
      logOut: () =>
        set((state) => {
          state.token = undefined;
          state.user = undefined;
        }),
      setUser: (user) =>
        set((state) => {
          state.user = user;
        }),
      setToken: (idToken) =>
        set((state) => {
          state.token = idToken;
        }),
      setEmail: (mail) =>
        set((state) => {
          state.email = mail;
        }),
    })),
    {
      name: 'user',
    },
  ),
);
